$mol_pop $mol_view
	showed? false
	align_vert \
	align_hor \
	direction \ltr
	align_enriched <= align \bottom_center
	prefer \vert
	auto /
		<= bubble null
	sub /
		<= Anchor null
	sub_visible /
		<= Anchor
		<= Follower $mol_follower
			offset <= bubble_offset /number
				0
				1
			align <= bubble_align /number
				0
				0
			Anchor <= Anchor
			Sub <= Bubble $mol_pop_bubble
				content <= bubble_content /$mol_view_content
				height_max <= height_max 9999

$mol_pop_bubble $mol_view
	sub <= content /$mol_view_content
	style *
		^
		maxHeight <= height_max 9999
	attr *
		^
		tabindex 0
		popover \manual
